'use client';

import Link from 'next/link';
import {usePathname} from 'next/navigation';
import {useContext} from 'react';

import CSS from './BottomBar.module.scss';
import Vector from '@/components/elements/vector/Vector';
import {resolveRoute} from '@/lib/routes';
import {UserDataContext} from '@/context/UserData';

const urls = () =>
  [
    {
      title: resolveRoute('base', undefined, true),
      url: resolveRoute('base'),
      vectorName: 'IoHomeOutline'
    },
    {
      title: resolveRoute('base.markets', undefined, true),
      url: resolveRoute('base.markets'),
      vectorName: 'FaSackDollar'
    },
    {
      title: resolveRoute('base.trade', undefined, true),
      url: resolveRoute('base.trade'),
      vectorName: 'logoSmall'
    },
    {
      title: resolveRoute('base.otc', undefined, true),
      url: resolveRoute('base.otc'),
      vectorName: 'SiHoppscotch'
    },
    {
      title: resolveRoute('base.user.wallets', undefined, true),
      url: resolveRoute('base.user.wallets'),
      vectorName: 'IoWallet'
    }
  ] as const;

export default function BottomBar() {
  const {isAuthenticated} = useContext(UserDataContext)!;
  const pathname = usePathname();

  return isAuthenticated ? (
    <nav className={CSS.bottomBar}>
      <ul>
        {urls().map((url, index) => (
          <li key={index}>
            <Link
              href={url.url}
              className={
                (
                  url.url === resolveRoute('base')
                    ? url.url === pathname
                    : pathname.startsWith(url.url)
                )
                  ? CSS.active
                  : undefined
              }>
              <Vector name={url.vectorName} className={CSS.icon} />
              <span>{url.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  ) : null;
}
